import {isTranslate} from './lang';

const YM_ID = 94769067;
const isWeb = process.env.REACT_APP_MOBILE_APP !== 'true';

export const YM_GOALS = {
    ADD_MONITOR: 'click_add_monitor_button',
    START_ADD_SITE: 'click_add_site_on_home_page',
    START_ADD_SERVER: 'click_add_server_on_home_page',
    START_ADD_PORT: 'click_add_port_on_home_page',
    START_ADD_DOMAIN: 'click_add_domain_on_home_page',
    EDIT_MONITOR: 'edit_site_monitor_monitoring_page',
    DELETE_MONITOR: 'delete_monitor_on_monitoring_page',
    PAUSE_MONITOR: 'pause_monitor_on_monitoring_page',
    RESUME_MONITOR: 'resume_monitor_on_monitoring_page',
    EXPORT_DATA_MONITOR: 'export_data_on_monitoring_page',
    SUBMIT_FORM_ADD_MONITOR: 'form_add_monitor_submit',
    APPLY_FILTER_MONITOR: 'apply_filter_on_monitoring_page',
    RESUME_MONITOR_DETAIL: 'resume_monitor_on_details_page',
    EDIT_MONITOR_DETAIL: 'edit_monitor_on_details_page',
    PAUSE_MONITOR_DETAIL: 'pause_monitor_on_details_page',
    DELETE_MONITOR_DETAIL: 'delete_monitor_on_details_page',
    EXPORT_DATA_MONITOR_DETAIL: 'export_data_on_details_page',
    CLICK_BANNER_BROTHERHOOD: 'banner_click',
    CLICK_TARIFF_PAY: 'click_tariff_pay_button',
    CLICK_EXTEND_TARIFF: 'click_extend_current_tariff_button',
    SUBMIT_FORM_LOGIN: 'form_login_submit',
    SUBMIT_FORM_REGISTRATION: 'form_registration_submit',
    SUBMIT_FORM_LEGAL_PAYMENT: 'legal_payment',
    TARIFF_RENEWAL_PAYMENT_START: 'tariff_renewal_payment_start',
    START_NEW_TARIFF_PAYMENT: 'start_new_tariff_payment',
} as const;

export type YmGoal = typeof YM_GOALS[keyof typeof YM_GOALS];

export const reachGoal = (goal: YmGoal) => {
    if (!isWeb) return;
    if (typeof window.ym !== 'function') return;
    if (isTranslate()) return;

    window.ym(YM_ID, 'reachGoal', goal);
};
